import { render, staticRenderFns } from "./ViewLevelRow.ts.vue?vue&type=template&id=19f4d91a"
import script from "./ViewLevelRow.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewLevelRow.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ViewLevelRow.ts.vue?vue&type=style&index=0&id=19f4d91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports